import { defineStore } from 'pinia'

export const useAnalyzeStore = defineStore('analyze', {
  state: () => ({
    resumeText: '',
    user: {},
    analysis: {},
    workHistory: [],
    missingFields: [],
    missingWorkHistory: false,
    aspirations: '',
    // Short-lived token from /users/register for the signup steps. Not a login token —
    // deliberately kept out of the teamwrkr-token cookie.
    onboardingToken: ''
  }),
  actions: {
    setResumeText(text) {
      this.resumeText = text
    },
    setUser(user) {
      this.user = user
    },
    setOnboardingToken(token) {
      this.onboardingToken = token || ''
    },
    // Drop the signup session (token + who/what was being onboarded) once signup is finished
    // or on logout, so it doesn't linger in persisted storage.
    clearOnboarding() {
      this.onboardingToken = ''
      this.user = {}
      this.resumeText = ''
    },
    setAnalysis(data) {
      this.analysis = data.analysis || {}
      if (data.user && Object.keys(data.user).length && data.user.email) {
        this.user = data.user
      }
      this.workHistory = data.workHistory || []
    },
    setMissingFields(fields) {
      this.missingFields = fields
    },
    setMissingWorkHistory(missing) {
      this.missingWorkHistory = missing
    },
    setAspirations(text) {
      this.aspirations = text
    }
  },
  persist: true
})